<ng-container>
	<h4 class="footer_header">VISIT OUR LOCATION</h4>
	<button class="mt-1 light-button w-100 d-reverse footer_sub" mat-stroked-button color="light" (click)="getDirections(selectedStore)" [disabled]="!selectedStore"> Get Directions &nbsp; &nbsp; &nbsp;<mat-icon>chevron_right</mat-icon>
	</button>
</ng-container>